import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import NewsletterIcon from "./icon-newsletter.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  ${theme.breakpoints.down("tablet")} {
    align-items: center;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;

  inline-size: 100%;

  ${theme.breakpoints.down("tablet")} {
    display: flex;
    flex-direction: column;
    gap: 12px;

    max-inline-size: 500px;
  }
`;

export const ContentContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    gap: 12px;
  }
`;

export const StyledNewsletterIcon = styled(NewsletterIcon)`
  inline-size: 48px;
  block-size: 48px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FirstLine = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 19.6px;
  text-align: start;
`;

export const SecondLine = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;
  text-align: start;

  u {
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  ${theme.breakpoints.up("tablet")} {
    display: block;
    justify-content: flex-end;
  }
`;

export const Button = styled.a`
  display: inline-flex;
  gap: 8px;
  align-items: center;

  padding-block: 10px;
  padding-inline: 16px;

  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  text-transform: uppercase;
  text-decoration: none;

  border-radius: 2px;

  background-color: #4585ff;

  cursor: pointer;

  transition: background-color 0.2s ease;

  &:hover {
    background-color: #3674e6;
  }
`;

export const SignUpLink = styled.a`
  color: #000000;
  font-weight: 700;
  text-decoration: underline;
`;
